<div #cmaPage class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->

  <div class="dash_base">
    <div class="">
      <section class="mt-40">
        <div class="container">
          <div class="whiteWrap">
            <div class="titleWrap">
              <div class="row">
                <div class="col-sm-12">
                  <h4 class="mt-1 float-left">{{ reportType }}</h4>
                  <div class="float-right d-flex m-d-block" *ngIf="!isInvestor">
                    <button
                      mat-flat-button
                      color="primary"
                      (click)="openCreateReportSheet()"
                      [matTooltip]="
                        reportType !== 'CMA'
                          ? 'Loan Officers can access our starting AVM value and initial comp search. REALTORS® create your CMA with our custom search and modeled values as you choose your own comps and adjustments. Voice activated for on the fly and free for unlimited use!'
                          : null
                      "
                      [matTooltipDisabled]="reportType === 'CMA'"
                    >
                      Create {{ reportType !== 'CMA' ? 'Smart Research' : 'CMA' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <app-cma-reports-filter class="my-4" (sortProperties)="filterChange($event)"></app-cma-reports-filter>
          </div>

          <div class="row px-2" *ngIf="reportCards.length">
            <div class="col-lg-4 col-md-6 col-sm-12 col-12 px-2" *ngFor="let reportCard of reportCards">
              <app-cma-report-card (reportDeleted)="reportDeleted($event)" [report]="reportCard"> </app-cma-report-card>
            </div>
          </div>

          <div
            class="flex_center w-100"
            *ngIf="!reportCards.length && !cmaState.isLoadingReport"
            style="height: calc(100vh - 17em)"
          >
            <div class="notFound text-center noData">
              <div>
                <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                <h4>No reports found!</h4>
              </div>
            </div>
          </div>
          <mat-paginator
            [length]="totalReports"
            [pageSize]="pageSize"
            [pageIndex]="currentPage"
            [pageSizeOptions]="[9, 15, 21]"
            (page)="onPageChange($event)"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </section>
    </div>
  </div>
  <!-- <app-create-cma-report *ngIf="cmaState.openCreateReportSheet | async" (reportFailed)="refreshComponent()">
  </app-create-cma-report> -->
</div>

<div *ngIf="cmaState.openCreateReportSheet | async" class="overlay-container">
  <app-create-cma-report (reportFailed)="refreshComponent()"></app-create-cma-report>
</div>

<div class="section-in-progress" *ngIf="cmaState.isLoadingReport && !cmaState.hideReportLoader">
  <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
  {{ cmaState.loadingMessage }}
</div>
